import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getFiles: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getFileById: async (id) => await apiClient.get(endpoints.getById(id)),
  getFileContentById: async (id) => await apiClient.get(endpoints.getContentById(id), { responseType: 'blob' }),
};
